import React, { useState } from 'react';
import { GoogleMap, MarkerF, InfoWindowF, useJsApiLoader } from '@react-google-maps/api';
import carIcon from '../../../assets/car.png';
import { Trip } from './types';

interface TripMapProps {
    trips: Trip[];
    isMobile: boolean;
    mapRef: React.MutableRefObject<google.maps.Map | null>;
}

const libraries: ("places" | "geometry")[] = ['places', 'geometry'];

const mapOptions = {
    streetViewControl: false,
    rotateControl: false,
    mapTypeControl: false,
};

const TripMap: React.FC<TripMapProps> = ({ trips, mapRef }) => {
    const [selectedTrip, setSelectedTrip] = useState<Trip | null>(null);
    
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: 'AIzaSyA5izcJ7TGIrfklTCrMx3Q2JmeK_zld1sc',
        libraries,
    });

    if (!isLoaded) return null;

    return (
        <GoogleMap
            mapContainerStyle={{ width: '100%', height: '100%' }}
            zoom={10}
            options={mapOptions}
            center={{ lat: 12.9716, lng: 77.5946 }}
            onLoad={(map) => {
                mapRef.current = map;
            }}
        >
            {trips.map((trip) => {
                const lat = Number(trip?.current_location?.lat);
                const lng = Number(trip?.current_location?.lng);
                if (!lat || !lng) return null;
                
                return (
                    <MarkerF
                        key={trip.id}
                        position={{ lat, lng }}
                        icon={{
                            url: carIcon,
                            scaledSize: new window.google.maps.Size(32, 32),
                        }}
                        onClick={() => setSelectedTrip(trip)}
                    />
                );
            })}

            {selectedTrip && selectedTrip.current_location && (
                <InfoWindowF
                    position={{ 
                        lat: Number(selectedTrip.current_location.lat), 
                        lng: Number(selectedTrip.current_location.lng) 
                    }}
                    onCloseClick={() => setSelectedTrip(null)}
                >
                    <>
                 <style>
                        {`
                            /* Hides the default Google Maps X button */
                            .gm-style-iw button.gm-ui-hover-effect {
                                display: none !important;
                            }
                            /* Removes inner scroll container padding */
                            .gm-style-iw-d {
                                overflow: hidden !important;
                                padding: 0 !important; 
                            }
                            /* Adjusts the main white box padding (Top, Right, Bottom, Left) */
                            .gm-style-iw-c {
                                padding: 6px 12px 8px 12px !important; 
                            }
                        `}
                    </style>

                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'space-between',
                            minWidth: '130px',
                            gap: '15px',
                        }}>
                            <div style={{ color: 'black', fontWeight: 'bold', fontSize: '15px' }}>
                                {selectedTrip.number_plate || "Unknown"}
                            </div>
                            <button 
                                onClick={() => setSelectedTrip(null)}
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                    color: '#555',
                                    padding: 0,
                                    margin: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                ✕
                            </button>
                        </div>
                    </>
                </InfoWindowF>
            )}
        </GoogleMap>
    );
};

export default TripMap;